<template>
  <div class="audio-progress">
    <div class="playBtn"  @click="changeAudioState" v-if="nowaudioPlay">
      <span class=" iconfont icon-play"></span>
    </div>
    <div class="playBtn"  @click="changeAudioState" v-else>
      <span class=" iconfont icon-play"  v-if="!audioPlay"></span>
      <span class=" iconfont icon-last-one22" v-else></span>
    </div>
    
    <div class="progress">
      <input v-if="ischange" type="range" name="" id="slider" class="ne-range "  ref="audioWidto" :value="0" max="100" @change="changeAudio" :style="{backgroundSize: '0% 100%' } " />
      <input v-else type="range" name="" id="slider" class="ne-range "  ref="audioWidto" :value="audioPercent || 0" max="100" @change="changeAudio" :style="{backgroundSize: audioPercent+'% 100%' } " />
    </div>
    <span class="duration">{{audioDuration | formatTime}}</span>
    <!-- <span class="duration">{{audioTime}}</span> -->

  </div>
</template>

<script>
import { mapState,mapGetters,mapMutations } from 'vuex';
export default {
  props: {playInfo:Object, },
  components:{},
  data(){
    return{
       slider: {
          color: '#FF6200',
          min: 0,
          max: 110,
          // icon: 'https://web-assets.dcloud.net.cn/unidoc/zh/hx.png',
          icon_w: '50rem',
          span_color: '#FF6200',
          span_fs: '0',
      },
      ischange: false,
      nowaudioPlay: false,
      audioTime: '',
    }
  },
  watch: {
    playInfo: {
      handler: function(newv,oldv){
        // if(JSON.stringify(newv) === '{}'||!this.curPlay) return;
        this.nowaudioPlay = false;
        this.audioTime = newv.dura_tion;
        if(!this.audioPlay){
          this.stopAudio();
          return;
        }
        this.playAudio(); return;

        if(JSON.stringify(newv) === '{}') return;
        this.audioTime = newv.dura_tion;
        if(newv.small&&(!this.curPlay||(this.curPlay&&!this.audioPlay))){
          this.nowaudioPlay = false;
          this.playAudio();
          return;
        }
        if(this.audioPlay&&this.curPlay.id===newv.id){
          this.ischange = false;
          this.nowaudioPlay = false;
        }
        // 判断上一个音频播放中与当前音频时暂停当前按钮与进度
        // if((this.curPlay.media_path!=newv.media_path)){
        if((this.curPlay.id!=newv.id)){
          this.ischange = true;
          // 判断上一个音频是否播放中
          
          if(this.audioPlay){
            this.nowaudioPlay = true;
          }else {
            this.nowaudioPlay = false;
          }
        }
      },
      immediate: true
    }
  },
  computed:{
    ...mapGetters("audio", {
      audioPercent: "getPercent",
      curPlay: 'getCurAudio',
    }),
    ...mapState("audio",{
      audioDuration:"audioDuration",
      audioCurrentTime:"audioCurrentTime",
      audioPlay:"playState",
      isRandom:"playOrder"
    })
  },
  methods:{
    ...mapMutations(['audio/updatePlayInfo','audio/updateCurTime','audio/updateMonitor','audio/updatePlayState','audio/updatePlayOrder']),
    
    
    //音频播放与暂停事件
    changeAudioState(){
      if(this.nowaudioPlay){
        this['audio/updatePlayState'](false)
        this['audio/updateCurTime'](0)
        this.playAudio();
        this.ischange = false;
        this.nowaudioPlay = false;
        return;
      }
      if(this.audioPlay){
        this.stopAudio()
      }else{
        this.playAudio()
      }
    },

    // 停止音频
    stopAudio(){
      this['audio/updatePlayState'](false)
    },
    // 播放音频
    playAudio(){
      this['audio/updatePlayInfo'](this.playInfo)
      this['audio/updatePlayState'](true)
    },

     //更改音频进度条
    changeAudio(e){
      let percent  = e.target.value
      let curTime = this.audioDuration *(percent / 100)
      this['audio/updateCurTime'](curTime)
      let music = document.getElementById("bgm")
      music.currentTime = curTime
      if(!this.audioPlay){
        this.stopAudio()
      }
    },
  },
}
</script>
<style scoped lang="scss">
  @import url(../../assets/css/range.css);
  .audio-progress{
    width: 100%;
    display: flex;
    align-items: center;
    .playBtn{
      color: var(--mainColor);
      font-size: 24rem;
      height: 24rem;
      cursor: pointer;
      display: flex;
      .iconfont{
        font-size: 24rem;
      }
    }
    .progress{
      width: calc(100% - 25rem - 35rem - 10rem);
      box-sizing: border-box;
      padding-left: 10rem;
    }
    .duration{
      // color: #414040;
      font-size: 12rem;
      margin-left: auto;

    }
  }
  
</style>